import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeContext } from 'styled-components';
import Like from '../../wire/tools-components/like';
import Comment from '../../wire/tools-components/comment';

const Container = styled.div`
  display: flex;
  align-items: center;

  > hr {
    width: 100%;
    border: none;
    border-bottom: 1px solid ${props => props.theme.secondaryColorLight};
  }

  > ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    margin-bottom: 12px;

    > li {
      padding-left: 16px;
      display: flex;
      flex-direction: column;
      justify-content: end;
      align-items: center;

      > span {
        display: flex;
        flex-direction: column;
        align-items: center;

        > .count {
          color: ${props => props.theme.primaryColor};
          font-size: 14px;
          font-family: ${props => props.theme.fontFamilyBody};
          font-weight: ${props => props.theme.fontWeightHeavy};
          line-height: 15px;
        }
  
        a {
          &:hover {
            text-decoration: none;
          }
  
          .icon-lw {
            font-size: 24px;
            color: ${props => props.theme.secondaryColor};
          }
        }
      }
    }  
  }
`;

export default function WireFooter({ wire }) {
  const { isMobile } = React.useContext(ThemeContext);

  return (
    <Container>
      <hr />
      {!isMobile && (
        <ul>
          <li><span><Like wire={wire} /></span></li>
          <li><Comment wire={wire} fullWire={false} /></li>
        </ul>
      )}
    </Container>
  );
}

WireFooter.propTypes = {
  wire: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
};
